import { Service, signal } from '@angular/core';

@Service()
export class ConnectionService {
  private readonly _isOnline = signal(navigator.onLine);

  public readonly isOnline = this._isOnline.asReadonly();

  public setOffline(): void {
    this._isOnline.set(false);
  }

  public restoreConnection(): void {
    this._isOnline.set(true);
  }

  public retryConnection(): void {
    this._isOnline.set(navigator.onLine);
  }
}
